// extracted by mini-css-extract-plugin
export default {"cls1":"Base-cls1_EDy","cls2":"Base-cls2_QLs Base-cls1_EDy"};